import React from 'react'
import styled from 'styled-components'
import { Link, navigate } from 'gatsby'
import Container from '../container'
import White from '../white'

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`

const Inner = styled.div`
  cursor: pointer;
  position: relative;
  width: 100%;
  aspect-ratio: 1440/878;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 35px;
  margin-top: 150px;
  background-color: #000;
  background-position: center center;
  background-image: url(${props => props.mainImage});
  background-size: cover;
  color: #fff;
  padding-bottom: ${props => props.vertical_align === 'flex-end' ? '100px' : '0px'};
  @media(max-width: 768px) {
    border-radius: 17px;
    margin-top: 50px;
  }
  h1 {
    text-align: center;
    text-transform: uppercase;
    font-family: Oswald,sans-serif;
    span {
      font-family: Oswald,sans-serif;
    }
  }
    a {
      color: #fff;
      border: none;
      outline: none;
      text-decoration: none;
    }
  }
`

const Overlay = styled.div`
    background-color: rgba(0,0,0,0.55);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 35px;
    z-index: 0;
    @media(max-width: 768px) {
      border-radius: 17px;
    }
`

const BannerLink = (props) => {

  const { heading, link, mainImage } = props.module;

  const title_bits = heading.split('|');

  const handleClick = (link) => {
    navigate(`/${link}`);
  }

  return (
    <div className="banner-link">
      <White>
        <Inner onClick={() => handleClick(link)} mainImage={mainImage.asset.publicUrl}>
          <Overlay></Overlay>
          <Flex>
            <h1><Link href={`/${link}`}>{title_bits.map((t, index) => <span key={index}>{t}<br /></span>)}</Link></h1>
          </Flex>
        </Inner>
      </White>
    </div>
  )
}

export default BannerLink
